import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import BriaButton from "../../../../../../components/common/BriaButton/BriaButton.tsx";
import RouterConstants from "../../../../../../constants/RouterConstants";
import useSecureNavigate from "../../../../../../hooks/useSecureNavigate";
import { isLegacyTgRoute } from "../../../../utils/tg-utils.ts";
import styles from "../../TgProjectViewer.module.scss";

const TgProjectDatasetsEmpty = () => {
	const { t } = useTranslation("tg", { keyPrefix: "datasets.dashboard" });
	const navigate = useSecureNavigate();
	const { projectId } = useParams();

	const handleUploadDatasetClick = () => {
		const route = isLegacyTgRoute()
			? `${RouterConstants.NEW_TG.LEGACY.PROJECTS.fullPath}/${projectId}/${RouterConstants.NEW_TG.DATASETS.createPath}`
			: `${RouterConstants.NEW_TG.PROJECTS.fullPath}/${projectId}/${RouterConstants.NEW_TG.MODELS.createPath}`;
		return navigate(route);
	};

	return (
		<Box className={styles.emptyState}>
			<Box>{t("emptyState")}</Box>
			<BriaButton onClick={handleUploadDatasetClick} buttonType={"primaryMedium"}>
				{t("createDataset")}
			</BriaButton>
		</Box>
	);
};

export default observer(TgProjectDatasetsEmpty);
